exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-collapse[data-v-602d945c] {\n  overflow-y: hidden;\n  min-height: 40px;\n  transition: all 200ms ease-in-out;\n}\n.aplaza-user-select[data-v-602d945c] {\n  height: 30px;\n  margin-left: 40px;\n  margin-bottom: 12px;\n  width: calc(100% - 40px);\n}\nul[data-v-602d945c] {\n  overflow: hidden;\n}\nli[data-v-602d945c] {\n  margin-bottom: 8px;\n  cursor: pointer;\n}\nli[data-v-602d945c]:active {\n  transform: scale(0.93);\n}", ""]);

// exports
